import React, { useState } from 'react';
import clsx from 'clsx';

import Button from 'components/ui/Button';

import css from './List.module.scss';

interface Props extends React.PropsWithChildren {
    direction?: 'vertical' | 'horizontal';
    align?: 'left' | 'center' | 'right';
    limit?: number;
    limitButtonText?: string;
    bordered?: boolean;
}

const List: React.FC<Props> & { Item: React.FC<React.PropsWithChildren> } = ({
    direction = 'vertical',
    align = 'left',
    limit = 0,
    limitButtonText,
    bordered,
    children,
}) => {
    const childrenArray = React.Children.toArray(children);
    const childrenLength = React.Children.count(children);
    const firstChildrenPart = childrenArray.slice(0, limit);
    const lastChildrenPart = childrenArray.slice(limit);
    const [hasMore, setHasMore] = useState(childrenLength > limit && limit > 0);

    return (
        <div className={clsx(css.wrapper, css[direction])}>
            <ul className={clsx(css.list, css[direction], css[align], bordered && css.bordered)}>
                {firstChildrenPart}
                {!hasMore && lastChildrenPart}
                {hasMore && (
                    <li>
                        <Button color="transparent" onClick={() => setHasMore(false)}>
                            {limitButtonText ?? `${lastChildrenPart.length}+`}
                        </Button>
                    </li>
                )}
            </ul>
        </div>
    );
};

const ListItem: React.FC<React.PropsWithChildren> = ({ children }) => <li className={clsx(css.item)}>{children}</li>;

List.Item = ListItem;

export default List as typeof List & { Item: React.FC<React.PropsWithChildren> };
